import React from 'react';
import { Image } from '..';
import { staticConfig } from '../../config/static';

interface IStaticResourceProps {
    imageId: string;
    alt?: string;
    className?: string;
}

export const StaticResource = ({ alt, className, imageId }: IStaticResourceProps): JSX.Element => {
    const imageUrl = staticConfig.apiBaseUrl + '/staticresourceservice/v1/images/';

    return (
        <>
            {imageId ? (
                <Image className={className} src={imageUrl + imageId} {...(alt && { alt: alt })} />
            ) : (
                <span className={className} />
            )}
        </>
    );
};
